import { ReactNode } from "react";

type SectionProps = {
  title: string;
  children: ReactNode;
  className?: string;
  mainClassName?: string;
};

const Section = ({
  title,
  children,
  className = "text-base",
  mainClassName = "space-y-4",
}: SectionProps) => (
  <div className={` ${mainClassName}`}>
    <h2 className={`text-[#212121] font-medium text-base uppercase  ${className}`}>{title}</h2>
    {children}
  </div>
);

export default Section;
